module.exports = __webpack_public_path__ + "img/svg/competition-card.06b3a74326e07ee7cf3aa8c665b2461c.svg";